export default "__VITE_ASSET__DgtOY5MB__"